import type { GetRowIdFunc, GridApi, ICellRendererParams, IRowNode } from 'ag-grid-community'
import type { MutableRefObject, RefObject } from 'react'

export const getRowId: GetRowIdFunc = (params) => params.data?.id

export function getLeafNodeChildren(params: ICellRendererParams) {
  return params.node.allLeafChildren.flat().map((node) => node.data)
}

export function getNodeById(key: string, id: string, gridRef: MutableRefObject<GridApi | null>): IRowNode | null {
  let foundNode: IRowNode | null = null
  gridRef.current?.forEachNode((node) => {
    if (node.group && node.allLeafChildren?.some((c) => c.data?.[key] === id)) {
      foundNode = node
    }
  })
  return foundNode
}

export function expandGroupById(key: string, id: string, gridRef: RefObject<GridApi>) {
  gridRef.current?.forEachNode((node) => {
    if (node.group && node.allLeafChildren?.some((c) => c.data?.[key] === id)) {
      node.setExpanded(true)
    }
  })
}
